import {
  BasicLayout,
  UserLayout,
  RouteView,
  PageView,
} from '@/layouts';
import { shallowRef } from 'vue';

export const asyncRouterMap = [
  // 首页
  {
    path: '/',
    name: 'index',
    component: shallowRef(BasicLayout),
    redirect: '/index',
    children: [
      // 首页
      {
        path: '/index',
        name: 'indexpage',
        component: shallowRef(PageView),
        meta: {
          title: '首页',
          icon: 'LineChartOutlined',
        },
        redirect: '/index/index',
        children: [
          {
            path: '/index/index',
            name: 'index-data',
            component: () => import(/* webpackChunkName: "merchants" */ '@/pages/index/index-data'),
            meta: {
              title: '首页',
            },
          },
          {
            path: '/index/industry',
            name: 'industry-data',
            component: () => import(/* webpackChunkName: "merchants" */ '@/pages/index/industry-data'),
            meta: {
              title: '行业数据',
            },
          },
          {
            path: '/index/stores',
            name: 'stores-data',
            component: () => import(/* webpackChunkName: "merchants" */ '@/pages/index/index-data-stores'),
            meta: {
              title: '门店数据',
            },
          },
        ],
      },
      // 商户管理
      {
        path: '/merchants',
        name: 'merchants',
        // hidden: true,
        component: shallowRef(PageView),
        meta: {
          title: '商户管理',
          icon: 'LaptopOutlined',
        },
        redirect: '/merchants/list',
        children: [
          {
            path: '/merchants/list',
            name: 'merchantsList',
            component: () => import(/* webpackChunkName: "merchants" */ '@/pages/merchants/list'),
            meta: {
              title: '商户列表',
            },
          },
          {
            path: '/merchants/detail/:mid',
            name: 'merchantsDetail',
            hidden: true,
            component: () => import(/* webpackChunkName: "merchants" */ '@/pages/merchants/detail'),
            meta: {
              title: '商户详情',
            },
          },
        ],
      },
      // 供应商管理
      {
        path: '/provider',
        name: 'provider',
        component: shallowRef(PageView),
        meta: {
          title: '供应商管理',
          icon: 'LaptopOutlined',
        },
        redirect: '/provider/list',
        children: [
          {
            path: '/provider/list',
            name: 'providerlist',
            component: () => import(/* webpackChunkName: "provider" */ '@/pages/provider/list'),
            meta: {
              title: '供应商列表',
            },
          },
          {
            path: '/provider/add',
            name: 'provideradd',
            hidden: true,
            component: () => import(/* webpackChunkName: "provider" */ '@/pages/provider/add'),
            meta: {
              title: '添加租用供应商',
            },
          },
          {
            path: '/provider/edit/:id',
            name: 'provideredit',
            hidden: true,
            component: () => import(/* webpackChunkName: "provider" */ '@/pages/provider/add'),
            meta: {
              title: '编辑租用供应商',
            },
          },
          {
            path: '/goods-provider/add',
            name: 'goodsprovideradd',
            hidden: true,
            component: () => import(/* webpackChunkName: "provider" */ '@/pages/provider/goods-add'),
            meta: {
              title: '添加商品供应商',
            },
          },
          {
            path: '/goods-provider/edit/:id',
            name: 'goodsprovideredit',
            hidden: true,
            component: () => import(/* webpackChunkName: "provider" */ '@/pages/provider/goods-add'),
            meta: {
              title: '编辑商品供应商',
            },
          },
          {
            path: '/provider/gatewaylist/:id',
            name: 'providergatewaylist',
            hidden: true,
            component: () => import(/* webpackChunkName: "provider" */ '@/pages/provider/gateway-list'),
            meta: {
              title: '绑定网关',
            },
          },
          {
            path: '/provider/tk/list',
            name: 'providerTkList',
            component: () => import(/* webpackChunkName: "provider" */ '@/pages/provider/tk-list'),
            meta: {
              title: '堂客账户列表',
            },
          },
        ],
      },
      // 门店管理
      {
        path: '/stores',
        name: 'stores',
        component: shallowRef(PageView),
        // hideChildrenInMenu: true,
        meta: {
          title: '门店管理',
          icon: 'HomeOutlined',
        },
        redirect: '/stores/list',
        children: [
          {
            path: '/stores/list',
            name: 'storesList',
            component: () => import(/* webpackChunkName: "stores" */ '@/pages/stores/list'),
            meta: {
              title: '门店列表',
            },
          },
          {
            path: '/stores/detail/:sid',
            name: 'storeDetail',
            component: shallowRef(RouteView),
            hidden: true,
            meta: {
              title: '门店详情',
            },
            redirect: to => {
              return { name: 'storeInfo', params: { sid: to.params.sid } }
            },
            children: [
              {
                path: '/stores/detail/info/:sid',
                name: 'storeInfo',
                component: () => import(/* webpackChunkName: "stores" */ '@/pages/stores/detail'),
                hidden: true,
                meta: {
                  title: '',
                },
              },
              {
                path: '/stores/placemap/:sid',
                name: 'placeMap',
                component: () => import(/* webpackChunkName: "stores" */ '@/pages/stores/placeMap'),
                hidden: true,
                meta: {
                  title: '实景选座配置',
                },
              },
            ]
          },
          {
            path: '/stores/minicodes/:sid',
            name: 'MiniCodesOutlined',
            component: () => import(/* webpackChunkName: "stores" */ '@/pages/stores/minicodes'),
            hidden: true,
            meta: {
              title: '门店二维码',
            },
          },
        ],
      },
      {
        path: '/goods',
        name: 'goods',
        component: shallowRef(PageView),
        meta: {
          title: '商品管理',
          icon: 'ShoppingOutlined',
        },
        redirect: '/goods/list',
        children: [
          {
            path: '/goods/list',
            name: 'goodsList',
            component: () => import(/* webpackChunkName: "goods" */ '@/pages/goods/goods-list'),
            meta: {
              title: '商品列表',
            },
          },
          {
            path: '/goods/add',
            name: 'goodsAdd',
            component: () => import(/* webpackChunkName: "goods" */ '@/pages/goods/goods-edit'),
            meta: {
              title: '添加商品',
            },
            hidden: true,
          },
          {
            path: '/goods/edit/:gid/:type',
            name: 'goodsEdit',
            component: () => import(/* webpackChunkName: "goods" */ '@/pages/goods/goods-edit'),
            meta: {
              title: '编辑商品',
            },
            hidden: true,
          },
          {
            path: '/goods/classify',
            name: 'goodsClassify',
            component: () => import(/* webpackChunkName: "goods" */ '@/pages/goods/goods-classify'),
            meta: {
              title: '商品分类',
            },
          },
        ],
      },
      // 交易管理
      {
        path: '/transaction',
        name: 'transaction',
        component: shallowRef(PageView),
        meta: {
          title: '交易管理',
          icon: 'DollarOutlined',
        },
        redirect: '/transaction/list',
        children: [
          {
            path: '/transaction/list',
            name: 'transactionList',
            component: () => import(/* webpackChunkName: "transaction" */ '@/pages/transaction/transaction-list'),
            meta: {
              title: '订单列表',
            },
          },
          {
            path: '/transaction/merchant-account-manage',
            name: 'transactionListMerchantAccountManage',
            component: () => import(/* webpackChunkName: "transaction" */ '@/pages/transaction/merchant-account-manage.vue'),
            meta: {
              title: '商户账户管理',
            },
          }, 
          {
            path: '/transaction/bill/:id/:type',
            name: 'transactionBill',
            component: () => import(/* webpackChunkName: "transaction" */ '@/pages/transaction/bill-details.vue'),
            meta: {
              title: '动账明细',
            },
            hidden: true,
          }
        ]
      },
      // 设备管理
      {
        path: '/devices',
        name: 'devices',
        component: shallowRef(PageView),
        meta: {
          title: '设备管理',
          icon: 'ControlOutlined',
        },
        redirect: '/device/gateway',
        children: [
          {
            path: '/device/gateway',
            name: 'gatewayList',
            component: () => import(/* webpackChunkName: "device" */ '@/pages/device/gateway'),
            meta: {
              title: '网关列表',
            },
          },
          {
            path: '/device/gateway-devices/:mac',
            name: 'gatewayDevices',
            hidden: true,
            component: () => import(/* webpackChunkName: "device" */ '@/pages/device/gateway-devices'),
            meta: {
              title: '网关设备列表',
            },
          },
          {
            path: '/device/bindbydevice',
            name: 'bindbydevice',
            hidden: true,
            component: () => import(/* webpackChunkName: "device" */ '@/pages/device/bind-by-device'),
            meta: {
              title: '设备绑定',
            },
          },
          {
            path: '/device/binddevice',
            name: 'binddevice',
            component: () => import(/* webpackChunkName: "device" */ '@/pages/device/bind'),
            meta: {
              title: '位置设备绑定',
            },
          },
          {
            path: '/device/commandrecord',
            name: 'commandrecord',
            component: () => import(/* webpackChunkName: "device" */ '@/pages/device/command-record'),
            meta: {
              title: '指令记录',
            },
          },
          {
            path: '/device/reportlist',
            name: 'reportlist',
            component: () => import(/* webpackChunkName: "device" */ '@/pages/device/report-list'),
            meta: {
              title: '设备上报记录',
            },
          },
          {
            path: '/device/ttlock',
            name: 'ttlock',
            component: shallowRef(RouteView),
            meta: {
              title: '通通锁',
            },
            hideChildrenInMenu: true,
            redirect: '/device/ttlockaccount',
            children: [
              {
                path: '/device/ttlockaccount',
                name: 'ttlockaccount',
                component: () => import(/* webpackChunkName: "device" */ '@/pages/device/ttlock-account'),
                meta: {
                  title: '通通锁账号',
                },
              },
              {
                path: '/device/ttlockbindrelation/:id',
                name: 'ttlockbindrelation',
                component: () => import(/* webpackChunkName: "device" */ '@/pages/device/ttlock-account-bind-relation'),
                meta: {
                  title: '绑定关系',
                },
              },
              {
                path: '/device/ttlockgateway/:id',
                name: 'ttlockgateway',
                component: () => import(/* webpackChunkName: "device" */ '@/pages/device/ttlock-account-gateways'),
                meta: {
                  title: '通通锁网关',
                },
              },
              {
                path: '/device/ttlockgateway/:id/locks/:macid',
                name: 'ttlockgatewaylocks',
                component: () => import(/* webpackChunkName: "device" */ '@/pages/device/ttlock-gateway-locks'),
                meta: {
                  title: '锁列表',
                },
              },
              {
                path: '/device/ttlockaccount/locks/:id',
                name: 'ttlockaccountlocks',
                component: () => import(/* webpackChunkName: "device" */ '@/pages/device/ttlock-account-locks'),
                meta: {
                  title: '通通锁',
                },
              },
              {
                path: '/device/ttlockaccount/:id/lockgateway/:lock_id',
                name: 'ttlockaccountlockgateways',
                component: () => import(/* webpackChunkName: "device" */ '@/pages/device/ttlock-lock-gateways'),
                meta: {
                  title: '通通锁网关',
                },
              },
              {
                path: '/device/ttlockaccount/:id/locklog/:lock_id',
                name: 'ttlockaccountlocklog',
                component: () => import(/* webpackChunkName: "device" */ '@/pages/device/ttlock-lock-log'),
                meta: {
                  title: '开门记录',
                },
              },
            ]
          },
          {
            path: '/device/interface',
            name: 'interface',
            component: shallowRef(RouteView),
            meta: {
              title: '外部对接',
            },
            hideChildrenInMenu: true,
            redirect: '/device/interfacelist',
            children: [
              {
                path: '/device/interfacelist',
                name: 'interfacelist',
                component: () => import(/* webpackChunkName: "device" */ '@/pages/device/interface-list'),
                meta: {
                  title: '外部对接',
                },
              },
              {
                path: '/device/interfacecommandlist/:id',
                name: 'interfacecommandlist',
                component: () => import(/* webpackChunkName: "device" */ '@/pages/device/interface-command-list'),
                meta: {
                  title: '指令列表',
                },
              },
              {
                path: '/device/interfacecommandadd/:oasid',
                name: 'interfacecommandadd',
                component: () => import(/* webpackChunkName: "device" */ '@/pages/device/interface-command-edit'),
                meta: {
                  title: '添加指令',
                },
              },
              {
                path: '/device/interfacecommandedit/:oasid/:id',
                name: 'interfacecommandedit',
                component: () => import(/* webpackChunkName: "device" */ '@/pages/device/interface-command-edit'),
                meta: {
                  title: '编辑指令',
                },
              },
            ]
          },
        ],
      },
      {
        path: '/message',
        name: 'systemMessage',
        component: () => import(/* webpackChunkName: "message" */ '@/pages/message/list'),
        meta: {
          title: '系统消息',
          icon: 'SoundOutlined',
        },
      },
      {
        path: '/account-mgr',
        name: 'accountManager',
        component: shallowRef(PageView),
        meta: {
          title: '账号管理',
          icon: 'TeamOutlined',
        },
        redirect: '/account-mgr/list',
        hideChildrenInMenu: true,
        children: [
          {
            path: '/account-mgr/list',
            name: 'accountManagerList',
            component: () => import(/* webpackChunkName: "accountmgr" */ '@/pages/account/list'),
            meta: {
              title: '账号列表',
            },
          },
          {
            path: '/account-mgr/bind-list/:account_id',
            name: 'accountManagerBindList',
            component: () => import(/* webpackChunkName: "accountmgr" */ '@/pages/account/account-binded-users'),
            meta: {
              title: '账号详情',
            },
          },
        ],
      },
      {
        path: '/settings',
        name: 'settings',
        component: shallowRef(PageView),
        meta: {
          title: '系统配置',
          icon: 'SettingOutlined',
        },
        redirect: '/settings/mchs',
        children: [
          {
            path: '/settings/mchs',
            name: 'mchs',
            component: shallowRef(RouteView),
            redirect: '/settings/mchs/list',
            meta: {
              title: '商户号管理',
            },
            hideChildrenInMenu: true,
            children: [
              {
                path: '/settings/mchs/list',
                name: 'mch-list',
                component: () => import(/* webpackChunkName: "settings" */ '@/pages/settings/mch-list'),
                meta: {
                  title: '列表',
                },
              },
            ],
          },
          {
            path: '/settings/versions',
            name: 'versions',
            component: shallowRef(RouteView),
            redirect: '/settings/versions/list',
            meta: {
              title: '更新说明',
            },
            hideChildrenInMenu: true,
            children: [
              {
                path: '/settings/versions/list',
                name: 'versions-list',
                component: () => import(/* webpackChunkName: "settings" */ '@/pages/settings/versions'),
                meta: {
                  title: '列表',
                },
              },
              {
                path: '/settings/versions/add',
                name: 'version-add',
                component: () => import(/* webpackChunkName: "settings" */ '@/pages/settings/version-add'),
                meta: {
                  title: '添加版本',
                },
              },
              {
                path: '/settings/versions/edit/:id',
                name: 'version-edit',
                component: () => import(/* webpackChunkName: "settings" */ '@/pages/settings/version-add'),
                meta: {
                  title: '编辑版本',
                },
              },
            ],
          },
          {
            path: '/settings/expmsg',
            name: 'expmsg',
            component: () => import(/* webpackChunkName: "settings" */ '@/pages/settings/expmsg-list'),
            meta: {
              title: '异常情况说明管理',
            },
          },
          {
            path: '/settings/themes',
            name: 'themes',
            component: shallowRef(RouteView),
            redirect: '/settings/themes/list',
            meta: {
              title: '主题管理',
            },
            hideChildrenInMenu: true,
            children: [
              {
                path: '/settings/themes/list',
                name: 'themes-list',
                hide: true,
                component: () => import(/* webpackChunkName: "settings" */ '@/pages/settings/themes'),
                meta: {
                  title: '列表',
                },
              }
            ],
          },
          {
            path: '/settings/miniapptemplates',
            name: 'miniapptemplates',
            component: shallowRef(RouteView),
            redirect: '/settings/miniapptemplates/list',
            meta: {
              title: '小程序页面模板管理',
            },
            hideChildrenInMenu: true,
            children: [
              {
                path: '/settings/miniapptemplates/list',
                name: 'miniapptemplateslist',
                hide: true,
                component: () => import(/* webpackChunkName: "settings" */ '@/pages/settings/miniapp-templates'),
                meta: {
                  title: '列表',
                },
              },
              {
                path: '/settings/miniapptemplates/add',
                name: 'miniapptemplatesadd',
                component: () => import(/* webpackChunkName: "settings" */ '@/pages/settings/miniapp-templates-add'),
                meta: {
                  title: '添加',
                },
              },
              {
                path: '/settings/miniapptemplates/editor/:id',
                name: 'miniapptemplateseditor',
                component: () => import(/* webpackChunkName: "settings" */ '@/pages/settings/miniapp-templates-add'),
                meta: {
                  title: '编辑',
                },
              },
              {
                path: '/settings/miniapptemplates/editorcontent/:id',
                name: 'miniapptemplateseditorcontent',
                component: () => import(/* webpackChunkName: "settings" */ '@/pages/settings/miniapp-templates-editor'),
                meta: {
                  title: '编辑内容',
                },
              },
            ],
          },
          {
            path: '/settings/console',
            name: 'console',
            component: shallowRef(RouteView),
            redirect: '/settings/console/panel',
            meta: {
              title: '控制台',
            },
            hideChildrenInMenu: true,
            children: [
              {
                path: '/settings/console/panel',
                name: 'console-panel',
                hide: true,
                component: () => import(/* webpackChunkName: "settings" */ '@/pages/settings/console-panel'),
                meta: {
                  title: '控制台',
                },
              },
            ],
          },
        ],
      },
      // 小程序管理
      {
        path: '/miniapp',
        name: 'miniapp',
        component: shallowRef(PageView),
        meta: {
          title: '小程序管理',
          icon: 'ContainerOutlined',
        },
        redirect: '/miniapp/apps',
        children: [
          {
            path: '/miniapp/apps',
            name: 'miniappApps',
            component: () => import(/* webpackChunkName: "miniapp" */ '@/pages/miniapp/miniApps'),
            meta: {
              title: '商户小程序列表',
            },
          },
          {
            path: '/miniapp/reviewrecord/:wxid',
            name: 'miniappReviewRecord',
            hidden: true,
            component: () => import(/* webpackChunkName: "miniapp" */ '@/pages/miniapp/reviewRecord'),
            meta: {
              title: '审核记录',
            },
          },
          {
            path: '/miniapp/feedback/:id',
            name: 'miniappReviewInfo',
            hidden: true,
            component: () => import(/* webpackChunkName: "miniapp" */ '@/pages/miniapp/feedback'),
            meta: {
              title: '审核反馈',
            },
          },
        ],
      },
    ],
  },

  // 页面错误
  {
    path: '/:pathMatch(.*)',
    redirect: '/404',
    hidden: true,
  },
];

/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap = [
  {
    path: '/user',
    component: UserLayout,
    redirect: '/user/login',
    hidden: true,
    children: [{
      path: 'login',
      name: 'login',
      component: () => import(/* webpackChunkName: "user" */ '@/pages/user/Login'),
    }]
  },
  {
    path: '/404',
    name: '404',
    component: () => import(/* webpackChunkName: "fail" */ '@/pages/exception/404'),
  },
  {
    path: '/403',
    name: '403',
    component: () => import(/* webpackChunkName: "fail" */ '@/pages/exception/403'),
  },
  // 工具页面
  {
    path: '/utils',
    redirect: '/utils/upload-image',
    component: BasicLayout,
    hidden: true,
    children: [{
      path: '/utils/upload-image',
      name: 'utils-upload-image',
      component: () => import(/* webpackChunkName: "utils" */ '@/pages/utils/image-uploader'),
    }]
  },
];
